<span
  class="input-mention-tag"
  data-cy="input-mention-tag"
  [attr.data-expandable]="tagExpansion"
  (mouseenter)="onMouseEnter($event)"
  (mouseleave)="onMouseLeave($event)">
  {{ value[0] !== prefix ? prefix : '' }}{{ value }}
  <ng-container #tagExpandVcr />
</span>

<ng-template #tagExpandTemplate>
  <div class="input-mention-tag-expanded" (mouseenter)="clearTimeout()" (mouseleave)="onMouseLeave($event)">
    <div class="avatar">
      <iu-avatar-ui [avatarInfos]="avatarInfos" />
    </div>
    <div class="infos">
      <span class="display-value">{{ value }}</span>
      <span>{{ userId }}</span>
    </div>
  </div>
</ng-template>
